module.exports = __webpack_public_path__ + "img/teacher.53a8fb36.svg";